import React, { ChangeEvent, FC } from 'react';
import { Flexbox } from '@bankiru/ui-kit/components/Flexbox';
import Checkbox from '@bankiru/ui-kit/core/Checkbox';
import Text from '@bankiru/ui-kit/core/Text';
import { CHECKBOX_DATA } from './constants';

type ConsentsListProps = {
	checkedCheckboxes: Record<string, boolean>;
	onCheckboxChanged: (isChecked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
};

export const ConsentsList: FC<ConsentsListProps> = ({ checkedCheckboxes, onCheckboxChanged }) => {
	return (
		<Flexbox flexDirection="column" gap="8">
			{CHECKBOX_DATA.map(({ id, titleContent, isRequired }) => (
				<Checkbox
					size="fs12"
					isChecked={checkedCheckboxes[id]}
					title={
						<Text color="secondary" size="fs12">
							{titleContent}
						</Text>
					}
					onChange={onCheckboxChanged}
					name={id}
					key={id}
					isError={isRequired && !checkedCheckboxes[id]}
				/>
			))}
		</Flexbox>
	);
};
